<template>
  <div class="quiz-card">
    <slot></slot> </div>
</template>

<style scoped>
.quiz-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 2rem;
  width: 100%;
  max-width: 600px;
  box-shadow: 0 10px 40px rgba(38, 72, 138, 0.12);
  border: 1px solid rgba(68, 137, 198, 0.15);
  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.quiz-card:hover {
  /* Efek 'bangkit' saat di-hover */
  /* transform: translateY(-10px) rotate(0deg) scale(1.02); */
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 15px 45px rgba(0,0,0,0.2);
}

@media (max-width: 480px) {
  .quiz-card {
    padding: 1.5rem;
    transform: rotate(0deg); /* Di mobile, buat kartu lurus agar lebih rapi */
  }
  .quiz-card:hover {
    transform: translateY(-5px); /* Efek bangkit lebih halus di mobile */
  }
}
</style>